export const CONVERSATION_STATUS = {
  ACTIVE: 'active',
  CREDIT_ADDED: 'credit-added',
  CREDIT_PENDING: 'credit-pending',
  FINISHED: 'finished',
  START: 'start',
  STOP: 'stop',
  RESUME: 'resume',
};
